import { ResponsiveContainer } from "recharts";

export default function ScrollChart({ data, itemH=32, maxH=268, children }) {
  const h = data.length * itemH + 50;
  return (
    <div className="relative min-w-0 overflow-hidden">
      <div className="overflow-y-auto overflow-x-hidden scrollbar-thin scrollbar-thumb-[#CBD5E1] scrollbar-track-[#F8FAFC]" style={{ maxHeight:maxH }}>
        <ResponsiveContainer width="100%" height={h}>{children}</ResponsiveContainer>
      </div>
      {h > maxH && (
        <div className="absolute bottom-0 left-0 right-0 h-[26px] bg-gradient-to-t from-white/[.96] to-transparent pointer-events-none flex items-end justify-center pb-[3px]">
          <span className="text-[8.5px] text-[#94A3B8] font-semibold tracking-[.5px]">↓ SCROLL FOR MORE</span>
        </div>
      )}
    </div>
  );
}

